import {Button, Group, Stepper} from '@mantine/core'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import InputErrorBox from '../../components/InputErrorBox'
import {handleSubmit, validateForm} from './SignUpFunction'
import {handleInputChange, handleOtherInputChange} from '../../CommonFunction'
import CustomTextInput from '../../components/CustomInput/CustomTextInput'
import CustomNumberInput from '../../components/CustomInput/CustomNumberInput'
import CustomMultiSelect from '../../components/CustomInput/CustomMultiSelect'
import Select2 from '../../components/select2'

const SignUp = () => {
  const initialState = {
    name: '',
    address: '',
    country: '',
    state: '',
    city: '',
    pincode: '',
    website: '',
    weekStartDay: '',
    weekendDays: [],
    financialYearStartDate: '',
    financialYearEndDate: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    mobile: '',
    inTime: '',
    outTime: '',
  }
  const [inputField, setInputField] = useState(initialState)
  const [inputError, setInputError] = useState<any>({})
  const [active, setActive] = useState(0)
  const nextStep = () => setActive((current) => (current < 3 ? current + 1 : current))
  const prevStep = () => setActive((current) => (current > 0 ? current - 1 : current))
  const [SubmitAPIStatus, setSubmitAPIStatus] = useState({
    loading: false,
  })
  return (
    <>
      <style>{`.form-control{
          background-color: #ffffff;
      }
      .form-select{
          background-color: #ffffff;
      }
      .form-control:focus {
  outline: none; 
  box-shadow: none;
  background-color: #ffffff;
      }
  @media (max-width: 767px) {
      .form-section, .image-section {
        padding: 1.5rem !important;
      }
    }
      `}</style>

      <div className='container-fluid' style={{minHeight: '94vh'}}>
        <div className='row'>
          <div
            className='card col-12 mt-10 col-md-8 d-flex flex-column justify-content-center align-items-center p-5 form-section'
            // style={{backgroundColor: '#99B9FF'}}
          >
            <div className='text-center mb-4'>
              <a
                href='/index.html'
                className='d-flex align-items-center gap-2 text-decoration-none'
              >
                <img
                  src='/media/logos/sialogo.png'
                  alt='Logo'
                  // height="70"
                  style={{width: '160px', height: '110px'}}
                  className='me-2'
                />
              </a>
            </div>
            <div className='w-100 px-4'>
              <Stepper active={active} onStepClick={setActive}>
                <Stepper.Step label='First step' description='Company Info'>
                  <div className='row '>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='name'
                        value={inputField.name}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Company Name'
                        id='name'
                        error={inputError.name}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='address'
                        value={inputField.address}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Address'
                        error={inputError.address}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='country'
                        value={inputField.country}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Country'
                        error={inputError.country}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='state'
                        value={inputField.state}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='State'
                        error={inputError.state}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='city'
                        value={inputField.city}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='City'
                        error={inputError.city}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomNumberInput
                        name='pincode'
                        value={inputField.pincode}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='PIN Code'
                        error={inputError.pincode}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='website'
                        value={inputField.website}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Website'
                        error={inputError.website}
                      />
                    </div>
                  </div>
                </Stepper.Step>
                <Stepper.Step label='Second step' description='Company Configuration'>
                  <div className='row'>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        type='date'
                        name='financialYearStartDate'
                        value={inputField?.financialYearStartDate}
                        onChange={(e) => {
                          handleInputChange(e, setInputField, inputError, setInputError)
                        }}
                        label={'Financial Year Start Date'}
                        error={inputError.financialYearStartDate}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        type='date'
                        name='financialYearEndDate'
                        value={inputField?.financialYearEndDate}
                        onChange={(e) => {
                          handleInputChange(e, setInputField, inputError, setInputError)
                        }}
                        label={'Financial Year End Date'}
                        error={inputError.financialYearEndDate}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomMultiSelect
                        label='Weekends'
                        data={[
                          {label: 'Monday', value: 'Monday'},
                          {label: 'Tuesday', value: 'Tuesday'},
                          {label: 'Wednesday', value: 'Wednesday'},
                          {label: 'Thursday', value: 'Thursday'},
                          {label: 'Friday', value: 'Friday'},
                          {label: 'Saturday', value: 'Saturday'},
                          {label: 'Sunday', value: 'Sunday'},
                        ]}
                        withAsterisk={true}
                        value={inputField?.weekendDays}
                        onChange={(e: any) => {
                          handleOtherInputChange(
                            e,
                            'weekendDays',
                            setInputField,
                            inputError,
                            setInputError
                          )
                        }}
                        error={inputError?.weekendDays}
                        size='md'
                        multiple={true}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <Select2
                        label='Week Start Day'
                        data={[
                          {label: 'Monday', value: 'Monday'},
                          {label: 'Tuesday', value: 'Tuesday'},
                          {label: 'Wednesday', value: 'Wednesday'},
                          {label: 'Thursday', value: 'Thursday'},
                          {label: 'Friday', value: 'Friday'},
                          {label: 'Saturday', value: 'Saturday'},
                          {label: 'Sunday', value: 'Sunday'},
                        ]}
                        value={inputField?.weekStartDay}
                        size='md'
                        withAsterisk={true}
                        onChange={(e: any) => {
                          handleOtherInputChange(
                            e,
                            'weekStartDay',
                            setInputField,
                            inputError,
                            setInputError
                          )
                        }}
                        error={inputError?.weekStartDay}
                      />
                    </div>
                  </div>
                </Stepper.Step>
                <Stepper.Step label='Final step' description='First User Info'>
                  <div className='row'>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='firstName'
                        value={inputField.firstName}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='First Name'
                        error={inputError.firstName}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='lastName'
                        value={inputField.lastName}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Last Name'
                        error={inputError.lastName}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='email'
                        value={inputField.email}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Email'
                        error={inputError.email}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='password'
                        value={inputField.password}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Password'
                        error={inputError.password}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomNumberInput
                        name='mobile'
                        value={inputField.mobile}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        label='Mobile'
                        error={inputError.mobile}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomNumberInput
                        name='inTime'
                        value={inputField.inTime}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        type='time'
                        label='In Time'
                        error={inputError.inTime}
                      />
                    </div>
                    <div className='fv-row  col-md-4 col-6 mb-3'>
                      <CustomTextInput
                        name='outTime'
                        value={inputField.outTime}
                        onChange={(event) =>
                          handleInputChange(event, setInputField, inputError, setInputError)
                        }
                        type='time'
                        label='Out Time'
                        error={inputError.outTime}
                      />
                    </div>
                  </div>
                </Stepper.Step>
                <Stepper.Completed>
                  Completed, click back button to get to previous step
                </Stepper.Completed>
              </Stepper>

              <Group className='justify-content-center' mt='xl'>
                <Button hidden={active === 0} variant='default' onClick={prevStep}>
                  Back
                </Button>
                <Button
                  hidden={active !== 2}
                  color='gray'
                  onClick={() => {
                    setActive(0)
                    setInputError({})
                    setInputField(initialState)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  loading={SubmitAPIStatus.loading}
                  onClick={() => {
                    if (active < 2) {
                      let {error, cnt} = validateForm(inputField, active)
                      setInputError(error)
                      if (cnt === 0) {
                        setActive(active + 1)
                      }
                    } else {
                      handleSubmit(
                        inputField,
                        initialState,
                        setInputField,
                        setInputError,
                        validateForm,
                        setSubmitAPIStatus,
                        setActive
                      )
                    }
                  }}
                >
                  {active < 2 ? 'Next step' : 'Signup'}
                </Button>
              </Group>
              {/* <div className='text-center mt-6'>
              <Button
                style={{fontSize: '18px'}}
                loaderPosition='center'
                loading={SubmitAPIStatus.loading}
                onClick={() => {
                  handleSubmit(
                    inputField,
                    initialState,
                    setInputField,
                    setInputError,
                    validateForm,
                    setSubmitAPIStatus
                  )
                }}
              >
                Signup
              </Button>
            </div> */}
              <div className='text-center mt-2 '>
                <p className=''>
                  Already have an account?
                  <Link to={'/login'} className='text-dark'>
                    <a href=''> Login</a>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div
            className='col-12 col-md-4 d-flex justify-content-center align-items-center p-4 image-section'
            // style={{backgroundColor: '#ffffff'}}
          >
            <img
              src='/media/logos/hero-img.png'
              alt='Signup Image'
              className='img-fluid'
              style={{minHeight: '80vh', objectFit: 'contain'}}
            />
          </div>
          {/* <div
            className='col-md-4 d-flex justify-content-center align-items-center'
            style={{backgroundColor: '#ffffff'}}
          >
            <img
              src={'/media/logos/hero-img.png'}
              className='img-fluid'
              alt='Signup Image'
              style={{maxWidth: '100%', height: 'auto'}}
            />
          </div> */}
        </div>
      </div>

      <div className='container-fluid px-0' style={{backgroundColor: '#dddddd'}}>
        <footer className={`text-center py-3 `}>
          <a href='/homepage' className='text-decoration-none'>
            <h6 className='footer-brand mb-0'>OfficeSIA 2024</h6>
          </a>
        </footer>
      </div>
    </>
  )
}

export default SignUp
